import { createFileRoute } from "@tanstack/react-router";
import { NegativeMarginSalesReport } from "@/features/reports/negative-margin-sales-report";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/ujemne-marze")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.ujemne-marze",
			location.pathname,
		);
	},
	component: NegativeMarginSalesReport,
});
